import React from "react";
import Slider from "react-slick";

const TestimonialData = [
  {
    id: 1,
    name: "Rahul Mehta",
    role: "Fashion Designer, Mumbai",
    text: "I've been shopping here for years, and their quality never disappoints. The fit is precise, and the fabric feels premium. Definitely my go-to for men's ethnic and casual wear.",
    img: "https://picsum.photos/101/101",
  },
  {
    id: 2,
    name: "Priya Nair",
    role: "Working Professional, Bangalore",
    text: "Fast delivery, stylish designs, and great customer service. I recently bought a linen set for the summer — super comfortable and worth every penny!",
    img: "https://picsum.photos/102/102",
  },
  {
    id: 3,
    name: "Arjun Patel",
    role: "Student, Delhi",
    text: "As someone on a budget, I love how they offer premium styles at affordable prices. The 70% off sale helped me upgrade my whole wardrobe without breaking the bank.",
    img: "https://picsum.photos/104/104",
  },
  {
    id: 5,
    name: "Anjali Sharma",
    role: "Entrepreneur, Pune",
    text: "I was skeptical at first, but the quality exceeded my expectations. Their sizing guide is accurate, and the clothes look exactly like the pictures. Highly recommend!",
    img: "https://picsum.photos/103/103",
  },
];

const Testimonials = () => {
  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    pauseOnHover: true,
    pauseOnFocus: true,
    responsive: [
      {
        breakpoint: 10000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="py-10 mb-10">
      <div className="container">
        {/* header section */}
        <div className="text-center  mb-10 max-w-[600px] mx-auto">
          <p data-aos="fade-up" className="text-sm text-primary">
            What our customers are saying
          </p>
          <h1 data-aos="fade-up" className="text-3xl font-bold">
            Testimonials
          </h1>
          <p data-aos="fade-up" className="text-xs text-gray-400">
           See why customers keep coming back for more.
          </p>
        </div>

        {/* Testimonial cards */}
        <div data-aos="zoom-in">
          <Slider {...settings}>
            {TestimonialData.map((data) => (
              <div className="my-6" key={data.id}> {/* ✅ key moved here */}
                <div className="flex flex-col gap-4 shadow-lg py-8 px-6 mx-4 rounded-xl dark:bg-slate-600 bg-primary/10 relative">
                  <div className="mb-4">
                    <img
                      src={data.img}
                      alt={data.name}
                      className="rounded-full w-20 h-20"
                    />
                  </div>
                  <div className="flex flex-col items-center gap-4">
                    <div className="space-y-3">
                      <p className="text-xs dark:text-slate-300 text-gray-500">
                        {data.text}
                      </p>
                      <h1 className="text-xl font-bold dark:text-slate-300 text-black/80">
                        {data.name}
                      </h1>
                    </div>
                  </div>
                  <p className="text-black/20  text-9xl font-serif absolute top-0 right-0"></p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
